import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { /* Checkbox,*/ Button } from "@ts-digital/vrc";
import { FormattedMessage } from "react-intl";

import "./style.css";
import UserInfo from "./userInfo";
import FirmInfo from "./firmInfo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getSettingsCompany, getSettingsCompanyForUser } from "../../store/actions/permissions";
import { /* TSDIGITAL_PORTALE_PUBLIC_URL,*/ TSID_PUBLIC_URL } from "../../config.js";
import useChangeAccountant from "../../customHooks/useChangeAccountant";

const Commercialista = () => {
  const { changeAccountantSelected } = useChangeAccountant();

  const main = useSelector((state) => state.main);
  const accountantIdSelected = main.accountantIdSelected;
  // const accountantUuidSelected = main.accountantUuidSelected;
  const companySelected = main.companySelected;
  const studio = useSelector((state) => state.studio);
  const user = useSelector((state) => state.user);

  const userUuidSelected = user?.profile?.uuid ? user?.profile?.uuid : user?.profile?.id;

  const [accountantSel /* setAccountantSel*/] = useState(accountantIdSelected);

  const dispatch = useDispatch();

  const renderStudioInfo = (infoMyCompany) => {
    return <FirmInfo infoMyCompany={infoMyCompany} />;
  };

  const renderPersonalInfo = () => {
    return <UserInfo user={user} />;
  };

  useEffect(() => {
    if (accountantSel !== accountantIdSelected) {
      dispatch(getSettingsCompany());
      dispatch(getSettingsCompanyForUser(
        companySelected, userUuidSelected, accountantIdSelected
      ));
      changeAccountantSelected(accountantSel);
    }
  }, [accountantSel]);

  /* const changeStudio = (idStudio) => {
    setAccountantSel(idStudio);
  };*/

  /* const getCurrentStudio = () => {
    const studioList = studio?.list;
    const currentStudio = studioList?.find((s) => s.uuid === accountantUuidSelected);
    return currentStudio;
  };*/

  const renderListCard = () => {
    let listCard = [];
    let color = "#09822a";
    if (studio.list) {
      for (let s in studio.list) {
        if (s) {
          let cardSelected = accountantIdSelected === studio.list[s].id;
          cardSelected ? (color = "#09822a") : (color = "#d82829");
          listCard.push(<div
            className={cardSelected ? "cardSkeleton box1_3 profile selected" : "cardSkeleton box1_3 profile"}
            style={{
              width: "344px",
              maxHeight: "240px",
              minHeight: "240px",
              display: "flex"
            }}
          >
            <div style={{ display: "flex" }}>
              <div className="iconCardBack">
                <FontAwesomeIcon icon={["far", "building"]} className="iconCard" />
              </div>
              <div className="studioCard">{studio.list[s].ragioneSociale}</div>
              {/* <div
                style={{
                  marginRight: "10px",
                  marginTop: "10px",
                  marginLeft: "auto"
                }}
              >
                <Checkbox onChange={() => changeStudio(studio.list[s].id)} checked={cardSelected ? true : false}></Checkbox>
              </div>*/}
            </div>
            <div
              style={{
                alignSelf: "flex-end",
                fontSize: "10px",
                marginRight: "10px"
              }}
            >
              {cardSelected ? "Attivo" : "Non attivo"}
              <FontAwesomeIcon icon={["fas", "circle"]} style={{ color: color, marginLeft: "7px", fontSize: "8px" }} />
            </div>
            <div className="studioCardFooter">{renderStudioInfo(studio.list[s])}</div>
          </div>);
        }
      }
    }
    return listCard;
  };

  // const currentStudio = getCurrentStudio();
  // const logoStudioUrl = currentStudio?.logoUrl;

  let cognomeNome = user.profile.lastName ? user.profile.lastName + " " + user.profile.firstName : "N/A";
  return (
    <div>
      <div  className="profile-header-refactor" style={{ display: "flex", marginTop: "40px", marginLeft: "30px" }}>
        {/* !logoStudioUrl ? (*/
          <div className="shortNameRound">
            {cognomeNome
              .split(" ")
              .map(function(s) {
                return s.charAt(0);
              })
              .join("")
              .substr(0, 2)}
          </div>
        /* ) : (
          <div className="logoStudioContainer" style={{ backgroundImage: `url(${logoStudioUrl})` }}></div>
        )*/}
        <div style={{ float: "right", marginLeft: "30px" }}>{renderPersonalInfo()}</div>
        <div>
          <a href={TSID_PUBLIC_URL}
            target="_blank"
            id="goToTSDigital"
            aria-label={"Accedi all'area personale"}
            tabIndex="0" rel="noreferrer">
            <Button kind="secondary">
              <FormattedMessage id="profile.personalArea"/>
            </Button>
          </a></div>
      </div>
      <div style={{ display: "flex", marginLeft: "30px" }}>
        {renderListCard()}
        <div
          style={{
            alignSelf: "flex-end",
            marginLeft: "8px",
            marginBottom: "8px"
          }}
        >
          {/* user?.profile?.language !== "es-ES" && <a
            href={TSDIGITAL_PORTALE_PUBLIC_URL + "#/" + accountantIdSelected + "/edit"}
            id="goToTSDigital"
            aria-label={"Link al portale Agyo per la modifica dell'anagrafica"}
            tabIndex="0"
          >
            <Button kind="secondary">
              <FormattedMessage id="profile.modifyRegistry" />
            </Button>
        </a>*/}
        </div>
      </div>
    </div>
  );
};

export default Commercialista;
